<template>
    <div class="cookie-notice-wrapper" v-if="!isCookieNoticeDismissed">
        <div class="cookie-notice uk-box-shadow-small">
            <div class="cookie-notice-content">
                <div class="cookie-notice-text">
                    <span class="cookie-message">
                        {{ translate('talron.general.cookieNotice') }}
                            
                            <router-link :to="{name: 'tos'}" class="cookie-link">
                                ב{{ translate('talron.footerNav.tos') }}  
                            </router-link>
                            ו 
                            <router-link :to="{name: 'privacy-policy'}" class="cookie-link">
                            {{ translate('talron.footerNav.privacyPolicy') }}
                            </router-link>
                    </span>
                </div>
                <button
                    class="cookie-notice-close"
                    @click="dismissCookieNotice"
                    :aria-label="translate('talron.general.cookieDismiss')"
                    type="button"
                >
                    {{ translate('talron.general.cookieAccept') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from '@/client/utilities/cookie.js';

export default {
    name: 'CookieNotice',
    
    data() {
        return {
            isCookieNoticeDismissed: false,
            cookieKey: 'talron_cookie_notice_dismissed'
        };
    },

    methods: {
        dismissCookieNotice() {
            // עדכון state מיד
            this.isCookieNoticeDismissed = true;
            // שמירה בקוקיס - תוקף: 365 ימים
            cookie.set(this.cookieKey, 'true', { expires: 365 });
        },

        checkCookieNotice() {
            // בדיקה אם המשתמש כבר סגר את ההודעה
            const cookieValue = cookie.get(this.cookieKey);
            if (cookieValue === 'true') {
                this.isCookieNoticeDismissed = true;
            }
        },

        translate(key) {
            return this.$t ? this.$t(key) : key;
        }
    },

    mounted() {
        this.checkCookieNotice();
    }
};
</script>

<style lang="scss" scoped>
.cookie-notice-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    animation: slideUp 0.3s ease-in-out;
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.cookie-notice {
    background-color: white;
    color: var(--global-primary-background-darkest);
    padding: 16px 20px;
    margin: 0;
    border-top: 3px solid var(--global-primary-background-darkest);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    font-weight: 600;
    @media (max-width: 640px) {
        padding: 12px 15px;
    }
}

.cookie-notice-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
}

.cookie-notice-text {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    font-size: 14px;
    line-height: 1.5;

    @media (max-width: 640px) {
        font-size: 13px;
        gap: 8px;
    }
}

.cookie-message {
    flex: 1;
}

.cookie-link {
    color: var(--global-primary-background-darkest);
    text-decoration: underline;
    cursor: pointer;
    //transition: color 0.2s ease;
}

.cookie-notice-close {
    background-color: var(--global-primary-background-darkest);
    border: none;
    cursor: pointer;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
    font-weight: 600;
    border-radius: 31px;
    font-size: 14px;
    color: white;
    width: 150px;
    height: 39px;
}
</style>
